import { DiscordSDK } from '@discord/embedded-app-sdk';
import { exchangeToken } from './api';

declare const __APP_ID__: string;

export interface DiscordContext {
  sdk: DiscordSDK;
  accessToken: string | null;
  channelId: string | null;
}

/**
 * Initialize the Discord Activity SDK and run the OAuth code-for-token
 * exchange via /api/auth/token (handled by bot DJ API). Returns the
 * access_token alongside the SDK handle. Auth failure does NOT throw —
 * Activity stays usable in read-only mode.
 */
export async function initDiscord(): Promise<DiscordContext> {
  const sdk = new DiscordSDK(__APP_ID__);
  await sdk.ready();
  let accessToken: string | null = null;
  try {
    const { code } = await sdk.commands.authorize({
      client_id: __APP_ID__,
      response_type: 'code',
      state: '',
      prompt: 'none',
      scope: ['identify'],
    });
    const tok = await exchangeToken(code);
    accessToken = tok.access_token;
    await sdk.commands.authenticate({ access_token: accessToken });
  } catch (e) {
    console.warn('craft-music: OAuth flow failed (continuing read-only)', e);
  }
  const channelId = (sdk as { channelId?: string | null }).channelId ?? null;
  return { sdk, accessToken, channelId };
}
